import { instance } from "./apiClient";

export const usersApi = {
  getCurrentUser: () => instance.get("/api/user").then((res) => res.data),

  updateUser: (payload) =>
    instance.put("/api/user", payload).then((res) => res.data),

  deleteSession: () => instance.delete("/api/session").then((res) => res.data),

  deleteUser: (payload) =>
    instance.delete("/api/user", { data: payload }).then((res) => res.data),

  addDevice: (payload) =>
    instance.post("/api/user/devices", payload).then((res) => res.data),

  deleteDeviceToken: (id) =>
    instance.delete(`/api/user/devices/${id}`).then((res) => res.data),
};
